<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" class="mt20">
        <el-table-column label="订单号" prop="orderNumber" align="center" fixed />
        <el-table-column label="数据类型" prop="dataType" align="center">
          <template slot-scope="{row}">
            {{getDataTypeName(row.dataType)}}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            {{getStateName(row.state)}}
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="amount" align="center" />
        <el-table-column label="创建时间" prop="createdTime" align="center" />
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import sysPayLogApi from '@/api/sys/sysPayLog'
export default {
  props: ['rowItem', 'activeType'],
  data() {
    return {
      list: [],
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      listLoading: false
    }
  },
  created() {
    this.handleShow()
  },
  methods: {
    getDataTypeName(type) {
      const typeMap = {
        1: '订单',
        2: '充值',
        3: '会议',
        4: '升级身份',
        5: '课程订单',
        7: '售后补款',
        8: '直播打赏'
      }
      return typeMap[type] || type
    },
    getStateName(state) {
      const stateMap = {
        0: '未支付',
        1: '已支付',
        2: '已退款'
      }
      return stateMap[state] || state
    },
    handleShow() {
      this.doQueryList({
        pageNo: 1
      })
    },
    async doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      if (this.rowItem) {
        if (this.rowItem.orderNumber) query.orderNumber = this.rowItem.orderNumber
        if (this.rowItem.dataType) query.dataType = this.rowItem.dataType
      }
      this.listLoading = true
      try {
        const { data } = await sysPayLogApi.fetchList(query)
        this.list = data.list || []
        this.total = data.total || 0
      } catch (error) {
        console.error('查询失败:', error)
      } finally {
        this.listLoading = false
      }
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.back-box {
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  span {
    margin-left: 8px;
  }
}
</style>






